import * as Yup from "yup";

const TRANSLATION_BASE_PATH = "_ADMIN._LEVELS";

export const formValidator = (translate: (key: string) => string) =>
	Yup.object({
		gradeName: Yup.string()
			.nullable()
			.trim()
			.required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`))
	});
